import { render, staticRenderFns } from "./AnalyticsSustainability.vue?vue&type=template&id=2919e890&scoped=true&"
import script from "./AnalyticsSustainability.vue?vue&type=script&lang=js&"
export * from "./AnalyticsSustainability.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsSustainability.vue?vue&type=style&index=0&id=2919e890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2919e890",
  null
  
)

export default component.exports